import React from 'react';
import {Typography} from '@material-ui/core';

const Notfound = () => (
    <Typography component="h1" variant="h4" align="left" color="textPrimary" gutterBottom={true}>
        Not found
    </Typography>
);

export default Notfound;
